function isMainCartPage() {
  return document.body.classList.contains('template-cart');
}

/** Header cart bubble: visible count + visually hidden "N item(s)" for SRs. */
function cartCountBubbleHtml(count) {
  const n = Number(count) || 0;
  let visuallyHidden = '0 items';
  if (n === 1) visuallyHidden = '1 item';
  else if (n > 1) visuallyHidden = n + ' items';
  return (
    '<span aria-hidden="true">' +
    n +
    '</span><span class="visually-hidden">' +
    visuallyHidden +
    '</span>'
  );
}

/**
 * Fade a set of nodes in/out; toggle loading on loadingSelector.
 * addLoadingBeforeFadeOut: true = mini-cart (spinner then fade); false = main cart (fade then spinner).
 */
function animateCartChromeOpacity(dir, opts) {
  const fadeTargets = opts.fadeTargets;
  const duration = opts.duration;
  const loadingSelector = opts.loadingSelector;
  const addLoadingBeforeFadeOut = opts.addLoadingBeforeFadeOut;
  const $fade = $(fadeTargets);
  const $loading = $(loadingSelector);

  if (dir == 'in') {
    $loading.removeClass('loading');
    $fade.animate({ opacity: 1 }, duration);
    return;
  }

  if (addLoadingBeforeFadeOut) {
    $loading.addClass('loading');
    $fade.animate({ opacity: 0 }, duration);
  } else {
    $fade.animate({ opacity: 0 }, duration, function () {
      $loading.addClass('loading');
    });
  }
}

/** Resolved flags on #cart-icon-bubble; viewport rules from cart-settings.js via window.BonafideCartViewport */
function shouldCartIconLinkToCartPage(cartIconAnchor) {
  let viewport = window.BonafideCartViewport;
  if (!viewport || !cartIconAnchor || !cartIconAnchor.dataset) {
    return false;
  }
  return viewport.isCartNavigationEnabledForDataset(cartIconAnchor.dataset, 'cartIconLinkToCart');
}

// Open minicart (cart template: drawer is not rendered — follow cart URL, do not hijack)
$('body').on("click", ".header__icon--cart", function(event) {
  if (isMainCartPage()) {
    return;
  }
  if (shouldCartIconLinkToCartPage(event.currentTarget)) {
    return;
  }
  window.refresh_cart();
  $('body').addClass('active-mini-cart');
  event.preventDefault();
});

// Close minicart on <body> click
$('.c-navigation-overlay').click(function(e) {
  if($('body').hasClass('active-mini-cart')){
    $('body').removeClass('active-mini-cart');
  }
});

// Close mini cart (scoped to drawer only — cart page reuses js-mini-cart-close-trigger outside .c-mini-cart)
$('body').on('click', '.c-mini-cart [js-mini-cart-close-trigger]', function(event) {
  event.preventDefault();
  $('body').removeClass('active-mini-cart');
  let toast = document.querySelector('toast-message');
  if (toast && $('.c-mini-cart__label').text().includes('Subscription')
    && ($('.c-mini-cart__product-name').text().includes('Revaree')
      || $('.c-mini-cart__product-name').text().includes('Clairvee')
      || $('.c-mini-cart__product-name').text().includes('Ristela')
      || $('.c-mini-cart__product-name').text().includes('Relizen')
      || $('.c-mini-cart__product-name').text().includes('Serenol'))) toast.open($('.c-mini-cart__product').length);
});

// Dynamic Discount toast open
$(document).mouseup(function(e){
  let container = $(".c-mini-cart");
  if (!container.length) return;
  if (!container.is(e.target) && container.has(e.target).length === 0 && container.css('transform') != 'none'){
    let toast = document.querySelector('toast-message');
    if (toast && $('.c-mini-cart__label').text().includes('Subscription')
    && ($('.c-mini-cart__product-name').text().includes('Revaree')
      || $('.c-mini-cart__product-name').text().includes('Clairvee')
      || $('.c-mini-cart__product-name').text().includes('Ristela')
      || $('.c-mini-cart__product-name').text().includes('Relizen')
      || $('.c-mini-cart__product-name').text().includes('Serenol'))) toast.open($('.c-mini-cart__product').length);
  }
});


// Decrease mini cart item quantity
$("body").on('click', ".button-wrapper button.reduction", function(e){
  e.preventDefault();
  let currentValue = $(this).closest('.c-mini-cart__input-wrapper-new').find('.c-mini-cart__input').val();
  currentValue--;
  if (currentValue<1){
    currentValue = 0;
  }
  $(this).closest('.c-mini-cart__input-wrapper-new').find('.c-mini-cart__input').val(currentValue).trigger('change');
  e.stopImmediatePropagation();
  return false;
});

// Increase mini cart item quantity
$("body").on('click', ".button-wrapper button.increment", function(e){
  e.preventDefault();
  let currentValue = parseInt($(this).closest('.c-mini-cart__input-wrapper-new').find('.c-mini-cart__input').val());
  currentValue++;
  $(this).closest('.c-mini-cart__input-wrapper-new').find('.c-mini-cart__input').val(currentValue).trigger('change');
  e.stopImmediatePropagation();
  return false;
});

/**
 * Manual free sample / GWP row: reset sample picker UI (must run before refresh_cart replaces mini-cart HTML).
 */
function syncManualFreeSampleUiForRemovedRow($row) {
  if ($row.attr('data-attr-free_sample') !== 'true') return;
  const variantId = $row.attr('data-variant-id');
  const $sample = $(".mini-cart__free-samples__products__product[data-variant_id='" + variantId + "']");
  $sample
    .find('.mini-cart__free-samples__products__product__add-to-cart')
    .removeClass('in-cart')
    .html('Add');
  $(".mini-cart__free-samples__products__product")
    .removeClass('disabled')
    .find('.mini-cart__free-samples__products__product__add-to-cart')
    .prop('disabled', false);
}

/**
 * Manual cross-sell row: reset cross-sell CTA (before mini-cart HTML refresh).
 */
function syncManualCrossSellUiForRemovedRow($row) {
  if ($row.attr('data-attr-cross_sell_product') !== 'true') return;
  const variantId = $row.attr('data-variant-id');
  const $cross = $(".mini-cart__cross-sell__products__product[data-variant_id='" + variantId + "']");
  $cross
    .find('.mini-cart__cross-sell__products__product__add-to-cart')
    .removeClass('in-cart')
    .html('Add');
}

function scheduleDynamicDiscountInit() {
  if (typeof window.DynamicDiscount !== 'undefined' && window.DynamicDiscount.init) {
    setTimeout(function () {
      window.DynamicDiscount.init();
    }, 250);
  }
}

/**
 * Runs whenever a mini-cart line hits quantity 0 (remove click, minus to zero, or typing 0).
 * Free-sample/GWP lines skip PDP buy-box sync
 */
function onMiniCartLineQuantityCommittedToZero($row) {
  syncManualFreeSampleUiForRemovedRow($row);
  syncManualCrossSellUiForRemovedRow($row);
  if ($row.attr('data-attr-free_sample') !== 'true' && !isMainCartPage()) {
    toggleBuyBoxPurchaseAllowed();
  }
  scheduleDynamicDiscountInit();
}

// Remove minicart item — same outcome as qty → 0 via input (handled in change listener)
$('body').on('click', '.cart-mini-item-removes', function (e) {
  e.preventDefault();
  animateCartContents('out');
  $(this).closest('.c-mini-cart__row').find('.c-mini-cart__input').val('0').trigger('change');
  return false;
});

// Minicart item quantity input change event
$(document).on('change', '.c-mini-cart__input', function(e) {
  e.preventDefault();
  animateCartContents('out');

  let $this = $(this).closest('.c-mini-cart__row');
  let variantId = $this.attr('data-variant-id');
  let key = $this.attr('data-key');

  let itemId = variantId;
  // If there are multiple items with the same variant id, use the item key instead
  const sameVariantId = document.querySelector('.cart-items-list-wrapper')?.querySelectorAll(`[data-variant-id="${variantId}"]`);
  if (sameVariantId?.length > 1) {
    itemId = key;
  }

  let quantity = parseInt($(this).val());
  let formData = {
    "id": itemId,
    "quantity": quantity
  }

  // Limit single box item quantity if max provided
  const singleBoxMaxQty = parseInt($this.attr('data-single-box-max'));
  if (singleBoxMaxQty && quantity > singleBoxMaxQty) {
    quantity = singleBoxMaxQty;
    formData.quantity = quantity;
  }

  // Limit B2B products to quantity_rule max
  const b2bProductMaxQty = parseInt($this.attr('data-b2b-max-quantity'));
  if (b2bProductMaxQty && quantity > b2bProductMaxQty) {
    quantity = b2bProductMaxQty;
    formData.quantity = quantity;
  }

  // Auto GWP manually removed - set session storage
  if($this.is("[data-is-auto-gwp]")) {
    sessionStorage.setItem('auto-gwp-was-manually-removed', true)
  }
  // Eligible product that gets an Auto GWP was removed - delete session storage
  else if($this.is("[data-gets-auto-gwp]")) {
    sessionStorage.removeItem('auto-gwp-was-manually-removed')
  }

  // Update cart data
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).then(response => response.json()).then(data => {
    if (quantity === 0) {
      // Sample/cross-sell DOM + PDP buy box + DynamicDiscount (same path as explicit remove)
      onMiniCartLineQuantityCommittedToZero($this);
    }
    refresh_cart(data);
    if (quantity === 0) {
      document.dispatchEvent(new CustomEvent("cart:item:removed", { detail: data }));
    } else if (quantity > 0) {
      document.dispatchEvent(new CustomEvent("cart:item:updated"));
    }
  }).catch((error) => {
    console.error('Error:', error);
  });
});

// Cart Item Input Enter Key
$(document).on('keydown', '.c-mini-cart__input', function(e) {
  const keyPressed = e.key || e.code;

  if (keyPressed && keyPressed.toUpperCase() === 'ENTER') {
    // Prevent submitting cart when pressing Enter on qty inputs
    e.preventDefault();
    // Temporarily remove focus so input change event can fire
    e.currentTarget.blur();
    e.currentTarget.focus();
  }
});

// Update any Buy Box buttons after item(s) added to cart
document.addEventListener('cart:item:added', e => {
  // Wait for mini-cart to be open before updating ATC text
  if (document.body.classList.contains('active-mini-cart')) {
    toggleBuyBoxPurchaseAllowed();
  } else {
    document.addEventListener('minicart:open', e => {
      toggleBuyBoxPurchaseAllowed();
    }, { once: true });
  }
});

function updatePurchaseStatusMessages(element, currentStatus) {
  // Set active and inactive text for Add to Cart button,
  // e.g. c-product-purchase__status--allowed or c-product-purchase__status--denied (js-purchase-allowed, js-purchase-denied)
  $(element).find(`.c-product-purchase__status:not(.c-product-purchase__status--${currentStatus}`).removeClass("is-active");
  $(element).find(`.c-product-purchase__status--${currentStatus}`).addClass("is-active");
}

/** Re-fetch add-ons HTML whenever a has-addons ATC is set back to allowed. */
function reloadAddonsMarkupForHasAddonsButton($btn) {
  if (!$btn.hasClass("has-addons")) return;
  const productUrl = $btn.attr("data-product-url") || window.location.pathname;
  if (!productUrl || !productUrl.includes("products")) return;
  $.ajax({
    type: "GET",
    url: productUrl + "?view=addons",
    dataType: "html",
    success: function (addonsHTML) {
      setTimeout(function () {
        $("#bundle-creator-container").hide();
        $("#bundle-creator-container").html(addonsHTML);
        $btn.parents(".c-product-purchase__form").find("input.c-product-purchase__radio:checked").trigger("click");
        $("product-addons").show();
        $("#bundle-creator-container").show();
      }, 1000);
    },
  });
}

function toggleBuyBoxPurchaseAllowed() {
  $.ajax({
    type: 'GET',
    cache: false,
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {

      // cart is empty, so enable ATC buttons (standard form + B2B)
      if(cart.items.length <= 0) {
        $(".c-product-purchase__form button[type='submit'][js-product-add-to-cart], .c-product-purchase__form__b2b button[type='submit'][js-product-add-to-cart]").each(function(){
          const $btn = $(this);
          $btn.prop('disabled', false);
          updatePurchaseStatusMessages($btn, "allowed");
          reloadAddonsMarkupForHasAddonsButton($btn);
        });

        const stickyAtcEmpty = document.querySelector("sticky-atc-button");
        if (stickyAtcEmpty) {
          updatePurchaseStatusMessages(stickyAtcEmpty, "allowed");
        }

        return;
      }

      // cart is not empty, so find all ATC buttons that belong to item in cart
      let productBtns = []
      let partialBundleBtns = []
      for (const item of cart.items) {
        if (item.properties._is_free_sample || item.properties._is_auto_GWP) {
          // Skip free samples, don't update ATC label
          continue;
        }

        const variantId = item.variant_id

        // regular product
        let $productBtnRegular = $(".c-product-purchase__form .c-product-purchase__type[data-variant-id='"+variantId+"']").parent().find('button[type="submit"]');
        if($productBtnRegular.length) productBtns.push($productBtnRegular);

        //  B2B product
        let $productBtnB2B = $(".c-product-purchase__form__b2b[data-variant-id='"+variantId+"']").find('button[type="submit"]');
        if($productBtnB2B.length) productBtns.push($productBtnB2B)

        // bundle products
        // find monthly purchase options using [data-swap-ids]. These will only be present on bundle buy boxes
        $(".c-product-purchase__form .c-product-purchase__type--subscription[data-swap-ids]").each(function(){
          const $purchaseOption = $(this);
          // check if bundle swap ids includes the cart item variant id
          if($purchaseOption.attr('data-swap-ids').includes(`${variantId}`)){
            // cart item is part of bundle: get the IDs and count of the bundle products
            const bundleIds = JSON.parse($purchaseOption.attr('data-swap-ids'));
            const productCountInBundle = Object.keys(bundleIds).length;

            // get an array of all the non-sample cart items' IDs, as strings
            const cartProducts = cart.items.filter((item) => !item.properties._is_free_sample && !item.properties._is_auto_GWP);
            const cartIds = cartProducts.map((item) => `${item.id}`);
            // running list of bundle items in the cart
            const bundleIdsInCart = {};

            // For each bundle product:
            Object.entries(bundleIds).forEach(([oneMonth, threeMonth]) => {
              // If either the 1-month or 3-month variant is in the cart, add to running list
              if (cartIds.includes(`${oneMonth}`) || cartIds.includes(`${threeMonth}`)) {
                bundleIdsInCart[oneMonth] = threeMonth;
              }
            });

            // Get total of bundle items actually in the cart
            const bundleItemsInCartCount = Object.keys(bundleIdsInCart).length;
            // If there are any bundle items in the cart:
            if (bundleItemsInCartCount > 0) {
              // Get product ATC button
              let $productBtnBundle = $purchaseOption.parent().find('button[type="submit"]');
              if($productBtnBundle.length) {
                // All items from bundle are in the cart, disable Add to Cart (same as standard products)
                if (bundleItemsInCartCount == productCountInBundle) {
                  productBtns.push($productBtnBundle);
                // Some items from bundle are in the cart, change Add to Cart messaging for partial bundle
                } else {
                  partialBundleBtns.push($productBtnBundle);
                }
              }
            }
          }
        });

      }

      // Disable each ATC button
      for (const $btn of productBtns) {
        $btn.prop('disabled', true);
        updatePurchaseStatusMessages($btn, "denied");
      }

      // Keep partial bundle ATC enabled, update messaging
      for (const $btn of partialBundleBtns) {
        $btn.prop('disabled', false);
        updatePurchaseStatusMessages($btn, "partial");
      }

      // Re-enable buy box buttons not locked by cart (e.g. main line removed but add-on line remains)
      const deniedOrPartialEls = new Set();
      productBtns.forEach(function ($b) {
        deniedOrPartialEls.add($b[0]);
      });
      partialBundleBtns.forEach(function ($b) {
        deniedOrPartialEls.add($b[0]);
      });
      $(
        ".c-product-purchase__form button[type='submit'][js-product-add-to-cart], .c-product-purchase__form__b2b button[type='submit'][js-product-add-to-cart]"
      ).each(function () {
        if (!deniedOrPartialEls.has(this)) {
          const $btn = $(this);
          $btn.prop("disabled", false);
          updatePurchaseStatusMessages($btn, "allowed");
          reloadAddonsMarkupForHasAddonsButton($btn);
        }
      });

      // Sticky ATC: mirror full deny vs partial vs allowed for this page
      const stickyAtcButton = document.querySelector("sticky-atc-button");
      if (stickyAtcButton) {
        if (productBtns.length) {
          updatePurchaseStatusMessages(stickyAtcButton, "denied");
        } else if (partialBundleBtns.length) {
          updatePurchaseStatusMessages(stickyAtcButton, "partial");
        } else {
          updatePurchaseStatusMessages(stickyAtcButton, "allowed");
        }
      }
    }
  });
}

// Refesh minicart
function refresh_cart(cart, callback = null){
  const hasCartPayload = cart && Array.isArray(cart.items);
  const cartEmpty = hasCartPayload && cart.items.length === 0;

  if (isMainCartPage() && hasCartPayload && cartEmpty) {
    window.location.href = '/cart';
    return;
  }

  if (isMainCartPage()) {
    // update progress bar
    if($(".cart-progress-bar__text").length){
      $.ajax({
        type: 'GET',
        cache: false,
        url: '/cart?view=mini-progress-bar',
        success: function(newPage){
          let newText = $(newPage).find(".cart-progress-bar__text");
          let newProgressBar = $(newPage).find('.cart-progress-bar__progress');
          $(".cart-progress-bar__text").replaceWith(newText); //update progress text
          let newWidth = newProgressBar.attr('data-width');
          $(".cart-progress-bar__progress").css('width',newWidth); //updates progress bar
        }
      });
    }
    // update cart totals
    $.ajax({
      type: 'GET',
      cache: false,
      url: '/cart?view=main-totals-ajax',
      success: function(totals){
        $(".main-cart-totals").html(totals);
      }
    });
    // update cart items
    $.ajax({
      type: 'GET',
      cache: false,
      url: '/cart?view=main-ajax',
      success: function(html){
        $("#main-cart-items .js-contents").html(html);
        let itemsInCart = $("#main-cart-items").find('input#items_in_cart').val();
        updateCounts(itemsInCart)
        // Ensure free sample function is available
        if (typeof check_free_sample_eligibility === "function") {
          check_free_sample_eligibility()
        }
        setTimeout(function(){
          animateCartContents('in');
        }, 500);
        document.dispatchEvent(new CustomEvent("cart:items:refreshed"));
        if(callback) callback(); //run callback if argument was supplied
      }
    });
    return;
  }

  //Update items
  $.ajax({
    type: 'GET',
    cache: false,
    url: '/cart?view=mini-ajax',
    success: function(cart){
      $(".hc-mini-table").html(cart);
      let itemsInCart = $(".hc-mini-table").find('input#items_in_cart').val();
      updateCounts(itemsInCart)
      // Ensure free sample function is available
      if (typeof check_free_sample_eligibility === "function") {
        check_free_sample_eligibility()
      }
      setTimeout(function(){
        animateCartContents('in');
      }, 100);
      document.dispatchEvent(new CustomEvent("cart:items:refreshed"));
      if(callback) callback(); //run callback if argument was supplied
    }
  });

  //Update progress bar
  if($(".cart-progress-bar__text").length){
    $.ajax({
      type: 'GET',
      cache: false,
      url: '/cart?view=mini-progress-bar',
      success: function(newPage){
        let newText = $(newPage).find(".cart-progress-bar__text");
        let newProgressBar = $(newPage).find('.cart-progress-bar__progress');
        $(".cart-progress-bar__text").replaceWith(newText); //update progress text
        let newWidth = newProgressBar.attr('data-width');
        $(".cart-progress-bar__progress").css('width',newWidth); //updates progress bar
      }
    });
  }

  // Update cart totals
  $.ajax({
    type: 'GET',
    cache: false,
    url: '/cart?view=mini-totals-ajax',
    success: function(totals){
      $("#cart__totals").html(totals);
    }
  });

  // Inject free samples if not present in current DOM
  if(!$(".mini-cart__free-samples").length){
    $.ajax({
      type: 'GET',
      cache: false,
      url: '/cart?view=mini-free-samples',
      success: function(samples){
        $(".mini-cart-items").after(samples);
      }
    });
  }
}

// Update minicart item totals
function updateCounts(itemsInCart){
  let itemsDisplayCount = itemsInCart || 0; // Use 0 if undefined

  $("[js-cart-item-count]").html('('+itemsDisplayCount+')');
  $(".cart-count-bubble").html(cartCountBubbleHtml(itemsDisplayCount));

  // Show/hide header + drawer chrome by line count. Selectors with no DOM match are skipped (jQuery no-op).
  const cartItemCountToggleSelectors =
    '.c-mini-cart__header .cart-qty, .header__icons .cart-count-bubble, #mini_checkout';
  if (itemsDisplayCount == 0) {
    $(cartItemCountToggleSelectors).hide();
  } else {
    $(cartItemCountToggleSelectors).show();
  }
}

// Show spinner and hide all cart contents
// @param - dir - value must be "in" or "out"
function animateCartContents(dir){
  if (isMainCartPage()) {
    animateCartChromeOpacity(dir, {
      fadeTargets:
        '#cart__items__container, .main-cart-totals, .mini-cart__cross-sell, .mini-cart__free-samples, #main-cart-items .js-contents',
      duration: 250,
      loadingSelector: '#main-cart-items',
      addLoadingBeforeFadeOut: false,
    });
    return;
  }

  animateCartChromeOpacity(dir, {
    fadeTargets: '.hc-mini-table, .cart-qty, #cart__totals',
    duration: 500,
    loadingSelector: '.hc-mini-table-wrapper',
    addLoadingBeforeFadeOut: true,
  });
}

// Run cart refresh and buy box enable checks on page load
if (!isMainCartPage()) {
  refresh_cart();
  toggleBuyBoxPurchaseAllowed();
}

// Detect when user returns to page via back button and refresh cart
window.addEventListener('pageshow', function(event) {
  // event.persisted is true when page is loaded from browser cache (back/forward button)
  if (event.persisted) {
    refresh_cart();
    toggleBuyBoxPurchaseAllowed();
  }
});